import { lazyNamed } from 'src/utils/lazyNamed';

const Accounts = {
  AccountsList: lazyNamed(() => import('./containers/AccountsList'), 'AccountsList'),
  AccountOverview: lazyNamed(() => import('./containers/AccountOverview'), 'AccountOverview'),
  ConversionTrackerForm: lazyNamed(() => import('./containers/ConversionTrackerForm'), 'ConversionTrackerForm'),
};

export default Accounts;
